import React, { useEffect, useState } from "react";
import { LoginInputs } from "../../../../Components/LoginInputs";
import { SignIn } from "../../../../Components/SignIn";
import {
  InputContainer,
  InputButton,
  HelperSpan,
  HandleGroupInput,
  HandleInputSenha,
  InputSenha,
} from "./styles";
import { SignInButton } from "../../../../Components/Buttons/SingnInButton";
import { RememberPassword } from "../../../../Components/RememberPassword";
import { useCartorio } from "../../../../Hooks/cartorio";
import { validateCPF } from "../../../../Services/validateCPF";
import { validateCNPJ } from "../../../../Services/validateCPNJ";
import { cnpjMask } from "../../../../Services/cnpjMask";
import { cpfMask } from "../../../../Services/cpfMask";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { Alert } from "../../../../Components/Error/Alert";
import { cartorioKey } from "../../../../Utils/localStorageKeys";
import { PerfilInput } from "../../../../Components/PerfilInput";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import theme from "../../../../Styles/theme";
import { validateEmail } from "../../../../Services/validaEmail";
import api from "../../../../Services/api";
import { sign } from "crypto";

export function Cadastrar() {
  const [cpf, setCpf] = useState("");
  const [cnpj, setCNPJ] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const [error, setError] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [ver1, setver1] = useState(false);
  const [ver2, setver2] = useState(false);

  const { signInCartorio, cartorio } = useCartorio();

  function handleSenha(pass: string) {
    setSenha(pass.trim());
  }

  async function handleSignIn() {
    setLoading(true);

    const cpf_cnpj_limpo = cpf.trim().length > 0?limpa_cpf_cnpj(cpf) : limpa_cpf_cnpj(cnpj);

    try {
      if (cpf_cnpj_limpo.length == 11 || cpf_cnpj_limpo.length < 11) {
        if (!validateCPF(cpf_cnpj_limpo)) {
          setError("O CPF digitado é inválido!");
          setErrorTitle("CPF inválido");

          return;
        }
      }

      if (cpf_cnpj_limpo.length > 11) {
        if (!validateCNPJ(cpf_cnpj_limpo)) {
          setError("O CNPJ digitado é inválido!");
          setErrorTitle("CNPJ inválido!");
          return;
        }
      }

      if (senha.length == 0) {
        setError("O campo senha não pode ser vázio!");
        setErrorTitle("Senha inválida!");
        return;
      }

      if(senha != confirmarSenha){
        setError("Você digitou duas senhas diferentes!");
        setErrorTitle("Senhas não conferem!");
        return;
      }

      if(!validateEmail(email)){
        setError("O email digitado é inválido!");
        setErrorTitle("Email inválido!");
        return;
      }

      if(nome.trim().length == 0){
        setError("O nome do cartório é inválido!");
        setErrorTitle("Nome inválido!");
        return;
      }


      const{data} = await api.post(`/cartorio`,{
        NOME:nome,
        CPF_CNPJ:cpf.length > 0 ?limpa_cpf_cnpj(cpf) :  limpa_cpf_cnpj(cnpj),
        EMAIL:email,
        SENHA:senha,
      });

      await signInCartorio(cpf.length > 0 ?limpa_cpf_cnpj(cpf) :  limpa_cpf_cnpj(cnpj), senha, false);

    } catch (error) {
      setError(
        `Não foi possível cadastrar seu cartório!s`
      );
      setErrorTitle("Dados de login inválidos!");
    } finally {
      setLoading(false);
    }
  }

  return (
    <SignIn
      children={
        <>
          <PerfilInput
            value={nome}
            ativo={true}
            title={"NOME"}
            execute={(str: string) => setNome(str)}
            disabled={false}
          />
          <HandleGroupInput>
            <PerfilInput
              value={cpf}
              ativo={true}
              title={"CPF"}
              execute={(str: string) => setCpf(str)}
              disabled={false}
            />
            <PerfilInput
              value={cnpj}
              ativo={true}
              title={"CNPJ"}
              execute={(str: string) => setCNPJ(str)}
              disabled={false}
            />
          </HandleGroupInput>

          <PerfilInput
            value={email}
            ativo={true}
            title={"EMAIL"}
            execute={(str: string) => setEmail(str)}
            disabled={false}
          />
          <HandleInputSenha>
            <InputSenha
              type={ver1 ? "text" : "password"}
              placeholder={"SENHA"}
              value={senha}
              onChange={(ev) => {
                setSenha(ev.target.value);
              }}
            />
            {!ver1 ? (
              <FaEye
                onClick={() => setver1(!ver1)}
                size={"max(13px, 1.5vw)"}
                style={{
                  marginLeft: "1vw",
                  color: theme.colors.dark,
                  cursor: "pointer",
                }}
              />
            ) : (
              <FaEyeSlash
                onClick={() => setver1(!ver1)}
                size={"max(13px, 1.5vw)"}
                style={{
                  marginLeft: "1vw",
                  color: theme.colors.dark,
                  cursor: "pointer",
                }}
              />
            )}
          </HandleInputSenha>

          <HandleInputSenha>
            <InputSenha
              type={ver2 ? "text" : "password"}
              placeholder={"SENHA"}
              value={confirmarSenha}
              onChange={(ev) => {
                setConfirmarSenha(ev.target.value);
              }}
            />
            {!ver2 ? (
              <FaEye
                onClick={() => setver2(!ver2)}
                size={"max(13px, 1.5vw)"}
                style={{
                  marginLeft: "1vw",
                  color: theme.colors.dark,
                  cursor: "pointer",
                }}
              />
            ) : (
              <FaEyeSlash
                onClick={() => setver2(!ver2)}
                size={"max(13px, 1.5vw)"}
                style={{
                  marginLeft: "1vw",
                  color: theme.colors.dark,
                  cursor: "pointer",
                }}
              />
            )}
          </HandleInputSenha>

          <InputButton>
            <SignInButton
              text="CADASTRAR"
              enable={false}
              type={"login"}
              execute={handleSignIn}
              loading={loading}
            />
          </InputButton>

          <Alert
            message={error}
            onClose={() => {
              setError("");
            }}
            open={error.length > 0}
            title={errorTitle}
          />
        </>
      }
    />
  );
}
